export const paidId = 4;

export const paymentTypeKeys = {
  card: 'card',
  cash: 'cash',
  invoice: 'invoice',
};

export const paymentTypeById = {
  1: paymentTypeKeys.card,
  2: paymentTypeKeys.cash,
  3: paymentTypeKeys.invoice,
};
